import Link from "next/link";
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { hideSignInRequiredModal } from "../../redux/counterSlice";
import { useRouter } from 'next/router';
import { LoginButton } from "../../components/header/LoginButton";
import { SignupButton } from "../../components/header/SignupButton";
const SignUpRequiredModal = ({
  returnTo = '/rider/claim'
}) => {
  const {
    signInRequiredModal
  } = useSelector(state => state.counter);
  const dispatch = useDispatch();
  const router = useRouter();
  return <div data-sentry-component="SignUpRequiredModal" data-sentry-source-file="signup-required.jsx">
      {/* <!-- Buy Now Modal --> */}
      <div className={signInRequiredModal ? "modal fade show block" : "modal fade"}>
        <div className="modal-dialog max-w-2xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="buyNowModalLabel">
                Signup required
              </h5>
              <button type="button" className="btn-close" onClick={() => {
              dispatch(hideSignInRequiredModal());
              router.back();
            }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" className="fill-jacarta-700 h-6 w-6 dark:fill-white" data-sentry-element="svg" data-sentry-source-file="signup-required.jsx">
                  <path fill="none" d="M0 0h24v24H0z" data-sentry-element="path" data-sentry-source-file="signup-required.jsx" />
                  <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z" data-sentry-element="path" data-sentry-source-file="signup-required.jsx" />
                </svg>
              </button>
            </div>

            <div className="modal-body p-6">
              <p>To use this feature, you must be logged in. Creating an account is free and easy. You will be brought back directly to this page once your sign up.</p>
              <p style={{
              marginTop: 12
            }}>If you already have an account, you can login now.</p>
              <LoginButton returnTo={returnTo} data-sentry-element="LoginButton" data-sentry-source-file="signup-required.jsx" />
            </div>

            <div className="modal-footer">
              <div className="flex items-center justify-center space-x-4">
                <SignupButton returnTo={returnTo} data-sentry-element="SignupButton" data-sentry-source-file="signup-required.jsx" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default SignUpRequiredModal;